import React, { useEffect, useState } from 'react';
import * as albcm from '../../albCommonModule';
import { makeStyles } from '@material-ui/core';
import { grey, teal } from '@material-ui/core/colors';
import { LoadingSpinner } from '../common/commonParts';
import logo from './alb_blog_logo.png';
import axios from 'axios';
import { makeUrlSearchParams } from '../../commonModule';
import { seagull } from '../../Rev';

export const useH2Style = makeStyles({
  feedHeader:{
    padding: 8, marginTop: 0, marginBottom: 16, 
    fontSize: 16, fontWeight: 200,
    color: teal[800], 
    borderBottom: '1px solid ' + teal[600],
    borderLeft: '2px solid ' + teal[600],
  }
})

const useStyles = makeStyles({
  blogContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px auto',
    maxWidth: '904px',
    overflow: 'hidden',
    marginBottom: 32,
  },
  blogCard: {
    border: '1px',
    marginBottom: '56px',
    padding: '8px',
    textDecoration: 'none',
    '& .blogCardContainer':{
      display: 'flex',
      '& .img': {

      },
      '& .main':{
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '16px',
        '& .text':{
          display: 'flex',
          flexDirection: 'column',
          '& .title': {
            marginBottom: '16px',
            fontSize: '18px',
            fontWeight: '500',
          },
          '& .about': {
            fontSize: '14px',
            color: grey[800],
            lineHeight: '1.6',
            display: "-webkit-box",
            "-webkit-line-clamp": "2",
            "-webkit-box-orient": "vertical",
            overflow: "hidden",
            "@media (max-width: 620px)": {
              display: 'none',
            }
          }
        },
        '& .sub': {
          display: 'flex',
          fontSize: '12px',
          paddingTop: '16px',
          color: grey[600],
          alignItems: 'center',
          '& img': {
            marginRight: '5px',
          },
          '& div': {
            marginRight: '5px',
          },
        },
      }
    },
    '&:hover .title':{
      textDecoration: 'underline',
    },
  }
})

const FeedRender = () => {
  const classes = useStyles();
  const h2class = useH2Style();
  const [feedDtList, setFeedDtList] = useState([]);
  useEffect(() => {
    if(feedDtList.length) return;
    let isMounted = true;
    if(isMounted && !feedDtList.length){
      (async() => {
        const parms = {a: "fetchSomeState", jino: "9999999999", item: "feeds"};
        const res = await axios.post(albcm.endPoint(), makeUrlSearchParams(parms));
        const feed_dtlist = res.data.dt[0] ?res.data.dt[0].state :false;
        if(isMounted && feed_dtlist) setFeedDtList(feed_dtlist.slice(0, 3));
      })();
    }
    return ()=>{
      isMounted = false;
    }
  }, [])
  const feed_nodes = feedDtList.map(feedDt => (
    <a href={feedDt.link} className={classes.blogCard} target='_blank'>
      <div className='blogCardContainer'>
        <div className='img'><img src={feedDt.imgList[0] ?feedDt.imgList[0] :logo} style={{width:112, height:112, objectFit: 'cover'}}/></div>
        <div className='main'>
          <div className='text'>
            <div className='title'>{feedDt.title}</div>
            <div className='about'>{feedDt.pTagList[0]+feedDt.pTagList[1]+feedDt.pTagList[2]}</div>
          </div>
          <div className='sub'>
            <img src={logo} alt="ロゴ" width={16} height={16}/>
            <div className={"name"}>アルバトロスブログ</div>
          </div>
        </div>
      </div>
    </a>
  ))
  if (seagull) return null;
  return(
    <>
    {feedDtList.length ?
      <div className={classes.blogContainer}>
      <h2 className={h2class.feedHeader}>アルバトロスブログ</h2>{feed_nodes}</div> 
      :<LoadingSpinner />
    }
    </>
  )
}
export default FeedRender;